<template>
  <v-card class="min-height fluid-modal">
    <nav class="theme--dark border-bottom" data-booted="true">
      <div class="v-toolbar__content">
        <div class="v-toolbar__title">Doctor Speciality</div>
        <div class="spacer"></div>
        <button
          type="button"
          class="v-btn v-btn--icon theme--dark"
          @click="$emit('close')"
        >
          <div class="v-btn__content cursor mr-1">
            <crossSVG />
          </div>
        </button>
      </div>
    </nav>
    <v-card-text
      :class="{
        'speciality-height': speciality.length > 5,
        'p-0': speciality.length < 5,
      }"
    >
      <div class="col-sm-12 p-0">
        <span
          v-for="(spe, i) in speciality"
          :key="i"
          class="speciality-chip mr-1 text-capitalize mb-2 inline-block"
          >{{ spe }}</span
        >
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
import { pickSvg } from "@/views/SVG";
export default {
  components: {
    ...pickSvg("crossSVG"),
  },
  props: ["speciality"],
};
</script>
